var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"logout-page"},[_c('el-row',{staticClass:"logout-panel-holder",attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{attrs:{"span":24}},[_c('h3',[_vm._v("กำลังออกจากระบบ...")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-700a3adc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/logout.vue
// module id = 1027
// module chunks = 1